module.exports = __webpack_public_path__ + "fonts/GenSenRounded-H.fb01506e.woff2";